export const sortAlphabetically = (a: string, b: string) => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
export const getArrayRandomValue = <T>(array: Array<T>) => array[Math.floor(Math.random() * array.length)];
